import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {Home1Component} from './components/home1/home1.component';
import {TestComponent} from './components/test/test.component';
import {PagesComponent} from './components/pages/pages.component';
import {NewsComponent} from './components/news/news.component';
import {MediaComponent} from './components/media/media.component';
import {SchoolComponent} from './components/school/school.component';
import {FacultyComponent} from './components/faculty/faculty.component';
import {ContactComponent} from './components/contact/contact.component';
import {AboutComponent} from './components/about/about.component';
import {LibraryComponent} from './components/library/library.component';
import {CccComponent} from './components/ccc/ccc.component';
import {culturalcouncilComponent} from './components/culturalcouncil/culturalcouncil.component';
import {OtherComponent} from './components/other/other.component';
import {AcademicComponent} from './components/academic/academic.component';
import {RecruitmentComponent} from './components/recruitment/recruitment.component';
import {ExaminationsComponent} from './components/examinations/examinations.component';
import {NaacComponent} from './components/naac/naac.component';
import {SupportFacilitiesComponent} from './components/support-facilities/support-facilities.component';
import {FacultyprofileComponent} from './components/facultyprofile/facultyprofile.component';
import {TenderComponent} from './components/tender/tender.component';
import {PhotogalleryComponent} from './components/photogallery/photogallery.component';
import {AdmissionComponent} from './components/admission/admission.component';
import {AdmissionTeamComponent} from './admissions/components/admission-team/admission-team.component';
import {ForeignStudentComponent} from './admissions/components/foreign-student/foreign-student.component';
import {ChairpersonAdmissionsComponent} from './admissions/components/chairperson-admissions/chairperson-admissions.component';
import {ContactAdmissionsComponent} from './admissions/components/contact-admissions/contact-admissions.component'
import {IprcellComponent} from './components/iprcell/iprcell.component';


const routes: Routes = [
	{
		path : "",
		component: Home1Component
	},
	{
		path : "school/:school",
		component: SchoolComponent
	},
	{
		path : "school/:school/:content",
		component: SchoolComponent
	},
	{
		path : "faculty",
		component: FacultyComponent
	},
	{
		path : "faculty/:fid",
		component: FacultyprofileComponent
	},
	{
		path : "contact",
		component: ContactComponent
	},
	{
		path : "about",
		component: AboutComponent
	},
	{
		path : "about/:pid",
		component: AboutComponent
	},
	{
		path : "iprcell",
		component: IprcellComponent 
	},
	{
		path: "iprcell/:pid",
		component: IprcellComponent
	},
	{
		path : "library",
		component: LibraryComponent
	},
	{
		path : "library/:pid",
		component: LibraryComponent
	},
	{
		path : "ccc",
		component: CccComponent
	},
	{
		path : "ccc/:pid",
		component: CccComponent
	},
	{
		path : "culturalcouncil",
		component: culturalcouncilComponent
	},
	{
		path : "culturalcouncil/:pid",
		component: culturalcouncilComponent
	},
	{
		path : "other",
		component: OtherComponent
	},
	{
		path : "other/:pid",
		component: OtherComponent
	},
	{
		path : "academic",
		component: AcademicComponent
	},
	{
		path : "academic/:pid",
		component: AcademicComponent
	},
	{
		path : "examinations",
		component: ExaminationsComponent
	},
	{
		path: "naac",
		"component": NaacComponent
	},
	{
		path : "recruitment",
		component: RecruitmentComponent
	},
	{
		path : "support",
		component: SupportFacilitiesComponent
	},
	{
		path : "support/photo-gallery",
		component : PhotogalleryComponent
	},
	{
		path : "support/:sid",
		component: SupportFacilitiesComponent
	},
	{
		path : "other",
		component: PagesComponent
	},
	{
		path : "other/:pid",
		component: PagesComponent
	},
	{
		path : "media",
		component: MediaComponent
	},
	{
		path : "media/:mid",
		component: MediaComponent
	},
	{
		path : "news",
		component: NewsComponent
	},
	{
		path : "news/:id",
		component: NewsComponent
	},
	{
		path : "event/:id",
		component: NewsComponent
	},
	{
		path : "event",
		component: NewsComponent
	},
	{
		path : "notice/:id",
		component: NewsComponent
	},
	{
		path : "notice",
		component: NewsComponent
	},
	{
		path : "tender",
		component: TenderComponent
	},
	{
		path : "tender/:pid",
		component: TenderComponent
	},
	{
		path : "test",
		component: TestComponent
	},
	{
		path : "admission",
		component : AdmissionComponent,
		children : [
			{
				path : "team",
				component : AdmissionTeamComponent
			},
			{
				path : "foreign-student",
				component : ForeignStudentComponent
			},
			{
				path : "chairperson-admissions",
				component : ChairpersonAdmissionsComponent
			},
			{
				path : "contact",
				component : ContactAdmissionsComponent
			},
		]
	},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts